import PAGE_TYPES from 'tradera-constants/page-types';
import { OPTIONAL_LANG } from 'tradera-apps/tradera/helpers/optional-lang';

export const traderaRoutes = {
    startPage: {
        path: [`${OPTIONAL_LANG}/`, `${OPTIONAL_LANG}`],
        pageType: PAGE_TYPES.START_PAGE,
        strict: true,
        exact: true
    },
    viewItemPage: {
        path: `${OPTIONAL_LANG}/item/:categoryId/:itemId/:itemSlug`,
        pageType: PAGE_TYPES.VIEW_ITEM_PAGE,
        mustLoadDataBeforePageTracking: true
    },
    traderaShopPage: {
        path: `${OPTIONAL_LANG}/tradera-shop/:urlSlug`,
        pageType: PAGE_TYPES.TRADERA_SHOP_PAGE
    },
    causesInfoPage: {
        path: `${OPTIONAL_LANG}/charity/how-to-become`,
        pageType: PAGE_TYPES.DEFAULT
    },
    causesPage: {
        path: `${OPTIONAL_LANG}/causes`,
        pageType: PAGE_TYPES.CUSTOM_RESULT_PAGE,
        mustLoadDataBeforePageTracking: true
    },
    causePage: {
        path: `${OPTIONAL_LANG}/cause/:causeSlug`,
        pageType: PAGE_TYPES.CUSTOM_RESULT_PAGE,
        mustLoadDataBeforePageTracking: true
    },
    upiPage: {
        path: `${OPTIONAL_LANG}/resolution/UPI2/:purchaseOrderId`,
        pageType: PAGE_TYPES.DEFAULT
    },
    inrPage: {
        path: `${OPTIONAL_LANG}/resolution/INR2/:purchaseOrderId`,
        pageType: PAGE_TYPES.DEFAULT
    },
    brandPage: {
        path: `${OPTIONAL_LANG}/brand/:brand`,
        pageType: PAGE_TYPES.BRAND_PAGE
    },
    brandListPage: {
        path: `${OPTIONAL_LANG}/brands/`,
        pageType: PAGE_TYPES.BRAND_LIST_PAGE
    },
    campaignPage: {
        path: [
            `${OPTIONAL_LANG}/shop/:crpId`,
            `${OPTIONAL_LANG}/campaign/:crpId`,
            `${OPTIONAL_LANG}/charity/:crpId`
        ],
        pageType: PAGE_TYPES.CUSTOM_RESULT_PAGE
    },
    categoryListPage: {
        path: `${OPTIONAL_LANG}/kategorier`,
        pageType: PAGE_TYPES.CATEGORY_LIST
    },
    checkoutConfirmationPage: {
        path: `${OPTIONAL_LANG}/shopping/ordercheckout/confirmation/:purchaseOrderId`,
        pageType: PAGE_TYPES.DEFAULT
    },
    checkoutPage: {
        path: `${OPTIONAL_LANG}/shopping/ordercheckout/:purchaseOrderId`,
        pageType: PAGE_TYPES.DEFAULT
    },
    cartPage: {
        path: `${OPTIONAL_LANG}/shopping/cart`,
        pageType: PAGE_TYPES.DEFAULT
    },
    searchResultPage: {
        path: `${OPTIONAL_LANG}/search`,
        pageType: PAGE_TYPES.SEARCH_RESULT_PAGE
    },
    favouriteSellersPage: {
        path: `${OPTIONAL_LANG}/favourite-sellers`,
        pageType: PAGE_TYPES.FAVOURITE_SELLERS_PAGE
    },
    landing_GantXTradera: {
        path: `${OPTIONAL_LANG}/gantxtradera`,
        pageType: PAGE_TYPES.DEFAULT
    },
    landing_StadiumXTradera: {
        path: `${OPTIONAL_LANG}/stadiumxtradera`,
        pageType: PAGE_TYPES.DEFAULT
    },
    profilePage: {
        path: `${OPTIONAL_LANG}/profile/:profilePageType(items|feedback|information)/:memberId/:aliasSlug`,
        pageType: PAGE_TYPES.PROFILE_PAGE
    },
    recommendationsPage: {
        path: `${OPTIONAL_LANG}/ma/endless-recommendation/:recommendationModeId(selected|endingSoon)`,
        pageType: PAGE_TYPES.ENDLESS_RECOMMENDATIONS_PAGE
    },
    reportItemPage: {
        path: `${OPTIONAL_LANG}/report-item/:itemId`,
        pageType: PAGE_TYPES.REPORT_ITEM_PAGE
    },
    verifyPage: {
        path: `${OPTIONAL_LANG}/verify/bankid`,
        pageType: PAGE_TYPES.DEFAULT
    },
    CombinedShippingInfoPage: {
        path: `${OPTIONAL_LANG}/frakt/samfrakt`,
        pageType: PAGE_TYPES.DEFAULT
    },
    ShippingInfoPage: {
        path: `${OPTIONAL_LANG}/frakt`,
        pageType: PAGE_TYPES.DEFAULT
    },
    swishApp2AppCallbackPage: {
        path: `${OPTIONAL_LANG}/shopping/payment/swish/:purchaseOrderId`,
        pageType: PAGE_TYPES.DEFAULT
    },
    ValuationPage: {
        path: `${OPTIONAL_LANG}/valuation`,
        pageType: PAGE_TYPES.CUSTOM_RESULT_PAGE
    },
    categoryResultPage: {
        path: [`${OPTIONAL_LANG}/category/:categoryId`],
        pageType: PAGE_TYPES.CATEGORY_RESULT_PAGE,
        exact: true
    },
    messagingiframe: {
        path: [
            `${OPTIONAL_LANG}/messagingiframe/thread/:threadId`,
            `${OPTIONAL_LANG}/messagingiframe/threads/:threadId`,
            `${OPTIONAL_LANG}/messagingiframe`
        ],
        pageType: PAGE_TYPES.DEFAULT
    },
    legacyCategoryResultPage: {
        path: [`${OPTIONAL_LANG}/:categoryNameAndId`],
        pageType: PAGE_TYPES.CATEGORY_RESULT_PAGE,
        exact: true
    },
    notFoundPage: {
        path: '*',
        pageType: PAGE_TYPES.ERROR_PAGE,
        exact: true
    }
};
